export default __webpack_public_path__ + "static/media/fabricationwork.66f097b3.png";